import { FC, Suspense } from "react"
import { HideFilters } from "../HideFilter/hide-filter"
import { Sorter } from "@/components/organisms/Sorter/sorter"

export const ProductControls: FC<{ showFilter: boolean }> = ({ showFilter }) => {
  return (
    <div className="flex items-center gap-6">
      {showFilter && <HideFilters />}
      <Suspense>
        <Sorter className="hidden lg:block" />
      </Suspense>
    </div>
  )
}
